<template>
  <main class="container-selfservice-main">
    <PageTitle
      :title="t('plan_setting')"
      :subtitle="
        t('self_service_plan_select', {
          userName: adminStore.getPartnerEmployeeInfo.nickname,
        })
      "
    />
    <SubscriptionDetails />

    <div id="card-element"></div>
  </main>
</template>

<script setup lang="ts">
import PageTitle from '@/components/domains/self-service/payment-settings/PageTitle.vue';
import SubscriptionDetails from '@/components/domains/self-service/payment-settings/SubscriptionDetails.vue';
import { usePayment } from '@/composables/shared/usePayment';
import { useAdminStore } from '@/stores/admin';
import { useSubscriptionStore } from '@/stores/subscription';

const { t } = useI18n();
const route = useRoute();

const adminStore = useAdminStore();
const subscriptionStore = useSubscriptionStore();

const { openCardManagePopup, openCreditAutoRechargePopup } = usePayment();

withDefaults(
  defineProps<{
    domain?: 'mobile' | 'self-service';
  }>(),
  {
    domain: 'mobile',
  }
);

// URL 쿼리스트링에 따라 모달 자동 열기
const handleRouteQuery = (modal) => {
  switch (modal) {
    case 'card':
      openCardManagePopup('MANAGE', subscriptionStore.paymentType);
      break;
    case 'refill':
      openCreditAutoRechargePopup();
      break;
  }
};

onMounted(async () => {
  if (route.query.modal) {
    handleRouteQuery(route.query.modal);
  }
});
</script>

<style scoped lang="scss"></style>
